import { redirectManager } from 'utils/gql/redirectManager';

export function redirectToPublicPage(urlSearchParams?: URLSearchParams, prevUrl?: string) {
  if (!window.location.pathname.includes('public.html')) {
    const urlSearchParamsString = urlSearchParams?.toString();
    redirectManager.persistRedirectUrl(prevUrl);
    window.location.href = `/public.html${urlSearchParamsString ? `?${urlSearchParamsString}` : ''}`;
  }
}

export function redirectToSetPassword(urlSearchParams: URLSearchParams = new URLSearchParams()) {
  urlSearchParams.set('source', '/set-password');
  const uid = urlSearchParams.get('uid');
  const verificationCode = urlSearchParams.get('verificationCode');

  if (!uid || !verificationCode) {
    return;
  }
  const urlSearchParamsString = urlSearchParams.toString();
  window.location.href = `/public.html${urlSearchParamsString ? `?${urlSearchParamsString}` : ''}`;
}
